import React, { Component } from "react";
import PropTypes from "prop-types";

import SignatureList from "./signatureList";
import SignaturePage from "./signaturePage";

class Signature extends Component {
  static propTypes = {
    documentSign: PropTypes.object,
    documentsToSign: PropTypes.object,
    getDocumentsToSign: PropTypes.func,    
    iframe: PropTypes.bool,
    isDocumentSign: PropTypes.bool,
    isErrorDocumentSign: PropTypes.bool,
    isErrorGettingDocumentsToSign: PropTypes.bool,
    isGettingDocumentsToSign: PropTypes.bool,
    signDocument: PropTypes.func,
    prevPath: PropTypes.string
  };

  componentDidUpdate() {
    const {
      documentSign,      
      iframe,
      isErrorDocumentSign,
      isGettingDocumentsToSign,
      isDocumentSign
    } = this.props;

    if (
      !isGettingDocumentsToSign &&
      !isDocumentSign &&
      iframe &&
      (isErrorDocumentSign || !documentSign)
    )
      navigate("/da-firmare");
  }

  render() {
    const {
      documentsToSign,
      isErrorGettingDocumentsToSign,
      signDocument,
      documentSign,
      iframe,
      isErrorDocumentSign,
      getDocumentsToSign,
      prevPath      
    } = this.props;
    let docs =
      documentsToSign &&
      documentsToSign.results &&
      documentsToSign.results._embedded
        ? documentsToSign.results._embedded.documentList
        : [];
    return !isErrorDocumentSign && documentSign && iframe ? (
      <SignaturePage
        getDocumentsToSign={getDocumentsToSign}
        url={
          documentSign && documentSign.payload.signUrl
            ? documentSign.payload.signUrl.replace("access_token", "sign_token")
            : null
        }
      />
    ) : !isErrorGettingDocumentsToSign ? (
      <div>
        {documentsToSign ? (
          <SignatureList
            total={documentsToSign.results}
            docs={docs}
            getDocumentsToSign={getDocumentsToSign}            
            signDocument={signDocument}
            documentsToSign={documentsToSign}
            prevPath={prevPath}
          />
        ) : null}
      </div>
    ) : null;
  }
}

export default Signature;
